/**
 * FeeTableRow Component
 * 수수료 테이블 행 컴포넌트
 */
import React from 'react';
import { formatCurrency } from '@/shared/utils/formatter';
import {
    RiderCommissionRow,
    COMMISSION_TYPE_OPTIONS,
    getAmountUnit,
    isUnderContract
} from '../lib/supplierFeeHelpers';

interface FeeTableRowProps {
    row: RiderCommissionRow;
    index: number;
    currentPage: number;
    isReadOnly: boolean;
    onCommissionTypeChange: (riderId: string, value: string) => void;
    onAmountChange: (riderId: string, value: string) => void;
    onShowHistory: (riderId: string, riderName: string) => void;
    onSave: (riderId: string) => void;
}

const FeeTableRow: React.FC<FeeTableRowProps> = ({
    row,
    index,
    currentPage,
    isReadOnly,
    onCommissionTypeChange,
    onAmountChange,
    onShowHistory,
    onSave
}) => {
    const underContract = isUnderContract(row.contStatus);
    const isDisabled = isReadOnly || !underContract;

    return (
        <tr
            style={!underContract ? {
                backgroundColor: '#f5f5f5',
                color: '#888'
            } : undefined}
            title={!underContract ? '계약 종료된 라이더입니다' : undefined}
        >
            {/* NO */}
            <td className="text-center">
                {(currentPage - 1) * 10 + index + 1}
            </td>

            {/* 라이더ID */}
            <td className="text-center" style={{ fontSize: '0.875rem', color: 'var(--color-gray-600)' }}>
                {row.riderId}
            </td>

            {/* 라이더명 */}
            <td>
                {row.riderName}
                {!underContract && (
                    <span style={{
                        marginLeft: '8px',
                        padding: '2px 6px',
                        fontSize: '0.7rem',
                        backgroundColor: '#e0e0e0',
                        borderRadius: '4px',
                        color: '#666'
                    }}>
                        계약 종료
                    </span>
                )}
            </td>

            {/* 수수료구분 */}
            <td>
                <select
                    className="filter-select"
                    style={{ width: '100%' }}
                    value={row.commissionType}
                    onChange={(e) => onCommissionTypeChange(row.riderId, e.target.value)}
                    disabled={isDisabled}
                >
                    {COMMISSION_TYPE_OPTIONS.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </td>

            {/* 금액 */}
            <td style={{ width: '100px', minWidth: '100px'}}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '0 8px' }}>
                    <input
                        type="text"
                        className="filter-input"
                        style={{ width: '60%', flex: 1, textAlign: 'right' }}
                        value={row.amount ? formatCurrency(row.amount) : ''}
                        onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '');
                            onAmountChange(row.riderId, value);
                        }}
                        placeholder="금액"
                        disabled={!row.commissionType || !underContract}
                    />
                    <span style={{ minWidth: '30px', fontSize: '0.875rem', color: 'var(--color-gray-600)' }}>
                        {row.commissionType ? getAmountUnit(row.commissionType) : ''}
                    </span>
                </div>
            </td>

            {/* 적용일 */}
            <td className="text-center">
                {row.applyDate || '-'}
            </td>

            {/* 수수료변경 히스토리 */}
            <td className="text-center">
                <button
                    className="btn btn-secondary"
                    style={{ fontSize: '0.875rem', padding: '6px 12px' }}
                    onClick={() => onShowHistory(row.riderId, row.riderName)}
                >
                    <i className="fas fa-history"></i>
                    <span style={{ marginLeft: '4px' }}>이력</span>
                </button>
            </td>

            {/* 저장 */}
            <td className="text-center">
                <button
                    className="btn btn-primary"
                    style={{ fontSize: '0.875rem', padding: '6px 12px' }}
                    onClick={() => onSave(row.riderId)}
                    disabled={!row.isEdited || !underContract}
                >
                    <i className="fas fa-save"></i>
                    <span style={{ marginLeft: '4px' }}>저장</span>
                </button>
            </td>
        </tr>
    );
};

export default FeeTableRow;
